import { render, staticRenderFns } from "./AreaMap.vue?vue&type=template&id=55f8bf01&scoped=true"
import script from "./AreaMap.vue?vue&type=script&lang=js"
export * from "./AreaMap.vue?vue&type=script&lang=js"
import style0 from "./AreaMap.vue?vue&type=style&index=0&id=55f8bf01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8bf01",
  null
  
)

export default component.exports